// D&D 2024 / SRD 5.2.1 multiclass Spellcasting table. Missing levels are zero.
const SPELLCASTING_SLOTS = Object.freeze([
  {},
  { 1: 2 }, { 1: 3 }, { 1: 4, 2: 2 }, { 1: 4, 2: 3 },
  { 1: 4, 2: 3, 3: 2 }, { 1: 4, 2: 3, 3: 3 }, { 1: 4, 2: 3, 3: 3, 4: 1 },
  { 1: 4, 2: 3, 3: 3, 4: 2 }, { 1: 4, 2: 3, 3: 3, 4: 3, 5: 1 },
  { 1: 4, 2: 3, 3: 3, 4: 3, 5: 2 }, { 1: 4, 2: 3, 3: 3, 4: 3, 5: 2, 6: 1 },
  { 1: 4, 2: 3, 3: 3, 4: 3, 5: 2, 6: 1 }, { 1: 4, 2: 3, 3: 3, 4: 3, 5: 2, 6: 1, 7: 1 },
  { 1: 4, 2: 3, 3: 3, 4: 3, 5: 2, 6: 1, 7: 1 }, { 1: 4, 2: 3, 3: 3, 4: 3, 5: 2, 6: 1, 7: 1, 8: 1 },
  { 1: 4, 2: 3, 3: 3, 4: 3, 5: 2, 6: 1, 7: 1, 8: 1 }, { 1: 4, 2: 3, 3: 3, 4: 3, 5: 2, 6: 1, 7: 1, 8: 1, 9: 1 },
  { 1: 4, 2: 3, 3: 3, 4: 3, 5: 3, 6: 1, 7: 1, 8: 1, 9: 1 },
  { 1: 4, 2: 3, 3: 3, 4: 3, 5: 3, 6: 2, 7: 1, 8: 1, 9: 1 },
  { 1: 4, 2: 3, 3: 3, 4: 3, 5: 3, 6: 2, 7: 2, 8: 1, 9: 1 },
]);

const PACT_MAGIC_SLOTS = Object.freeze([
  { slotLevel: 0, maximum: 0 },
  { slotLevel: 1, maximum: 1 }, { slotLevel: 1, maximum: 2 },
  { slotLevel: 2, maximum: 2 }, { slotLevel: 2, maximum: 2 },
  { slotLevel: 3, maximum: 2 }, { slotLevel: 3, maximum: 2 },
  { slotLevel: 4, maximum: 2 }, { slotLevel: 4, maximum: 2 },
  { slotLevel: 5, maximum: 2 }, { slotLevel: 5, maximum: 2 },
  { slotLevel: 5, maximum: 3 }, { slotLevel: 5, maximum: 3 },
  { slotLevel: 5, maximum: 3 }, { slotLevel: 5, maximum: 3 },
  { slotLevel: 5, maximum: 3 }, { slotLevel: 5, maximum: 3 },
  { slotLevel: 5, maximum: 4 }, { slotLevel: 5, maximum: 4 },
  { slotLevel: 5, maximum: 4 }, { slotLevel: 5, maximum: 4 },
]);


module.exports = { SPELLCASTING_SLOTS, PACT_MAGIC_SLOTS };
